
import React, { useState } from 'react';
import type { View } from '../types';
import { useAuth } from '../hooks/useAuth';
import { useRecipeManager } from '../hooks/usePrinciplesManager';
import { useExplanationGuidelinesManager } from '../hooks/useExplanationGuidelinesManager';
import { useProblemManager } from '../hooks/useProblemManager';
import Header from './Header';
import RecipeModal from './RecipeModal';
import ExplanationGuidelinesModal from './ExplanationGuidelinesModal';
import { SettingsProvider, useSettings } from '../contexts/SettingsContext';
import SettingsModal from './SettingsModal';
import Spinner from './Spinner';
import ExamRecognitionView from './ExamRecognitionView';

const NaesinAppContent: React.FC = () => {
  const [isRecipeModalOpen, setRecipeModalOpen] = useState(false);
  const [isGuidelinesModalOpen, setGuidelinesModalOpen] = useState(false);
  const [isSettingsModalOpen, setSettingsModalOpen] = useState(false);

  const { user, logout } = useAuth();
  const { 
    recipe, 
    addPrinciple, updatePrinciple, deletePrinciple, 
    addGeneralTool, updateGeneralTool, deleteGeneralTool,
    addSpecificTool, updateSpecificTool, deleteSpecificTool
  } = useRecipeManager();
  const { guidelines, addGuideline, updateGuideline, deleteGuideline } = useExplanationGuidelinesManager();
  
  const { isLoading: isSettingsLoading } = useSettings();

  const { onAddMultipleBaseProblems, allFolderPaths } = useProblemManager(user?.uid, recipe, guidelines);

  if (isSettingsLoading) {
    return (
        <div className="min-h-screen bg-[var(--color-bg-primary)] flex items-center justify-center">
            <Spinner message="사용자 설정 로딩 중..." />
        </div>
    );
  }

  return (
      <div className="min-h-screen bg-[var(--color-bg-primary)] transition-colors duration-300">
        <Header
          onOpenRecipe={() => setRecipeModalOpen(true)}
          onOpenGuidelines={() => setGuidelinesModalOpen(true)}
          onLogout={logout}
          onOpenSettings={() => setSettingsModalOpen(true)}
        />
        <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <ExamRecognitionView 
              guidelines={guidelines} 
              onAddMultipleBaseProblems={onAddMultipleBaseProblems}
              allFolderPaths={allFolderPaths}
            />
        </main>
        
        <RecipeModal
          isOpen={isRecipeModalOpen}
          onClose={() => setRecipeModalOpen(false)}
          recipe={recipe}
          onAddPrinciple={addPrinciple}
          onUpdatePrinciple={updatePrinciple}
          onDeletePrinciple={deletePrinciple}
          onAddGeneralTool={addGeneralTool}
          onUpdateGeneralTool={updateGeneralTool}
          onDeleteGeneralTool={deleteGeneralTool}
          onAddSpecificTool={addSpecificTool}
          onUpdateSpecificTool={updateSpecificTool}
          onDeleteSpecificTool={deleteSpecificTool}
        />
        
        <ExplanationGuidelinesModal
          isOpen={isGuidelinesModalOpen}
          onClose={() => setGuidelinesModalOpen(false)}
          guidelines={guidelines}
          onAddGuideline={addGuideline}
          onUpdateGuideline={updateGuideline}
          onDeleteGuideline={deleteGuideline}
        />
        
        <SettingsModal 
          isOpen={isSettingsModalOpen}
          onClose={() => setSettingsModalOpen(false)}
        />
      </div>
  );
}


const NaesinApp: React.FC = () => {
  return (
    <SettingsProvider>
      <NaesinAppContent />
    </SettingsProvider>
  )
}

export default NaesinApp;
